import { graphql, useStaticQuery } from 'gatsby'
import React from 'react'
import TextHeader from '../TextHeader/TextHeader'
import { AccreditationList } from './Accreditation.styled'
import AccreditationItem from './AccreditationItem'

function Accreditation() {
  const data = useStaticQuery(graphql`
    query {
      contentfulComponentConfigData {
        accreditationTitle
        accreditationList {
          contentful_id
          title
          subtitle
          image {
            gatsbyImageData
            description
          }
        }
      }
    }
  `)

  const accreditationTitle = data?.contentfulComponentConfigData?.accreditationTitle || ''
  const accreditationList = data?.contentfulComponentConfigData?.accreditationList || []
  const rowNumber = Math.ceil(accreditationList.length / 2)

  return (
    <div className="outer">
      <div className="inner">
        <div className="margin-40">
          <TextHeader title={accreditationTitle} />
        </div>
        <AccreditationList rows={rowNumber || 1}>
          {accreditationList.length > 0 &&
            accreditationList.map((item) => (
              <li key={item.contentful_id}>
                <AccreditationItem
                  image={item.image?.gatsbyImageData}
                  title={item.title}
                  subtitle={item.subtitle}
                />
              </li>
            ))}
        </AccreditationList>
      </div>
    </div>
  )
}

export default Accreditation
